module.exports = __webpack_public_path__ + "media/Video 82.25540c63.mp4";